import { useNavigate, useParams } from "react-router-dom";
import { CoachDetail } from "../../components";
import { useEffect, useState } from "react";
import { ICoach } from "../../models/ICoach";
import { getCoachById } from "../../api/coaches";
import { Loader } from "../../ui";

const RepresenterDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [coach, setCoach] = useState<ICoach>();

  const getCoachDetail = async () => {
    setLoading(true);
    try {
      const { data } = await getCoachById(id!);
      setCoach(data);
      document.title = `Representers - ${data.firstName} ${data.lastName ?? ""}`;
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
  };

  const handleBack = (count: number) => {
    navigate(-(count + 1));
  };

  useEffect(() => {
    getCoachDetail();
  }, []);

  return (
    <div className="representer-detail-page">
      {loading ? (
        <Loader />
      ) : (
        <div>
          <CoachDetail item={coach as ICoach} onBack={handleBack} />
        </div>
      )}
    </div>
  );
};

export default RepresenterDetail;
